<template>
  <div class="guides">
    <!--nav-bread :page="{name:'extUsers', title: $t('iaoBreadCrumbs.guides.title'), sub: $t('iaoBreadCrumbs.guides.sub')}"/-->
    <div class="directory-list">
      <div v-for="reference of referencesList" :key="reference.id" class="guides-list-item">
        <div class="guides-list-item-head">
          <h3 class="guides-list-item-title" v-bind:class="{ active: displayBody == reference.id }" @click="openBody(reference.id)">{{reference.title}}</h3>
        
        </div>

        
        <div class="directory-references-list" v-if="displayBody == reference.id">
          <div class="guides-list-item-head">
            <h3 class="guides-list-item-title">{{reference.title}}</h3>
            <el-button type="primary" size="small" @click="addItemHandler(reference.id)">Добавить</el-button>
          </div>
          <reference-item
            v-for="item of reference.items"
            :key="item.id"
            :reference-id="reference.id"
            :reference-item="item"
            :active-edit-item-id="activeEditItemId"
            @onEditItem="editItemHandler"
            @onDeleteItem="deleteItemHandler"
            @onCancelEditItem="cancelEditItemHandler"
            @onAddFile="addFileHandler"
            @onRemoveFile="removeFileHandler"
          />
        </div>
      </div>
    </div>

    <el-dialog title="Создание записи" :visible.sync="createDialogVisible">
      <div class="guides-modal">
        <div class="guides-modal-row">
          <label>
            <span>Название</span>
            <el-input v-model="newReferenceName" autocomplete="off"></el-input>
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button>Отмена</el-button>
        <el-button type="primary" @click="saveReferencesItem()">Сохранить</el-button>
      </span>
    </el-dialog>

    <el-dialog width="400px" title="Добавление файла" :visible.sync="showAddFileModal">
      <el-form :model="addFileForm" ref="addFileForm" label-width="120px" class="demo-ruleForm" label-position="top">
        <el-form-item prop="file">
          <div class="files-upload-list">
            <el-upload
                ref="upload"
                class="upload-demo"
                drag
                action=""
                :http-request="uploadFile"
                :file-list="addFileForm.newFiles"
                :multiple="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">{{$t('feed.settings.common.commonSimpleForm.upload[0]')}} <em>{{$t('feed.settings.common.commonSimpleForm.upload[1]')}}</em></div>
            </el-upload>

            <ul class="files-list" v-if="addFileForm.files && addFileForm.files.length">
              <li class="files-list__item-title">{{$t('feed.settings.common.commonSimpleForm.uploaded')}}:</li>
              <li class="files-list__item" v-for="file in addFileForm.files" :key="file.link">
                <span class="files-list__item-name">
                  {{file.filename}}
                </span>
                <el-link type="primary" icon="el-icon-download" :href="file.link" :underline="false">{{$t('feed.settings.common.commonSimpleForm.download')}}</el-link>
              </li>
            </ul>
          </div>
        </el-form-item>
        <!--        <el-button type="primary" @click="submitForm()">Отправить</el-button>-->
        <!--        <el-button type="primary" @click="resetForm('addFileForm')">Отменить</el-button>-->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  // components
  import NavBread from '@/components/navBread/NavBread';
  import ReferenceItem from "./ReferenceItem.vue"

  // api
  import { getFullReferencesApi, getReferenceAddItemApi, getReferenceRemoveItemFromApiApi } from "../../../../api/references";

  // vuex
  import { mapGetters } from "vuex";
  import {referenceAddFileApi, referenceRemoveFileApi} from "../../../../api/files";
  import notify from "../../../../helpers/notify";
  import {GET_EXT_USERS} from "../../../../store/actions/users";
  import {GET_EXT_USERS_RELS} from "../../../../store/actions/users";

  // functions
  import {iaoApi} from '../../../../helpers/iaoApi';

  export default {
    name: 'IaoGuides',
    data() {
      return {
        group: '',
        referencesList: [],
        references: [],
        currentReferenceId: null,
        createDialogVisible: false,
        newReferenceName: '',
        newReferenceKeyword: '',
        newReferenceKeywordList: [],
        activeEditItemId: null,
        addFileForm: {
          files: []
        },
        showAddFileModal: false,
        addFileReferenceItemId: null,
        roles: this.$t('user.roles'),
        displayBody: 1,
      };
    },
    computed: {
      ...mapGetters([
        "extUsers",
        "extUsersRels",
        "isAdmin",
      ]),
    },
    methods: {
      openBody(id) {
        this.displayBody = id
        console.log('id', this.displayBody)
      },
      closeBody() {
        this.displayBody = 0
      },
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      loadReferences() {
        console.log('iaoApi', iaoApi())
        const params = {
          group_id: iaoApi(),
          is_user_id: true
        }
        getFullReferencesApi(params).then((resp) => {
          this.referencesList = resp.data;
        });
      },
      addItemHandler(id) {
        this.currentReferenceId = id;
        this.createDialogVisible = true;
      },
      editItemHandler(id) {
        this.activeEditItemId = id;
      },
      cancelEditItemHandler() {
        this.activeEditItemId = null;
      },
      deleteItemHandler(id) {
        getReferenceRemoveItemFromApiApi({ item_id: id, api_id: iaoApi() }).then(() => {
          this.loadReferences();
        })
      },
      addFileHandler(id) {
        this.addFileReferenceItemId = id;
        this.showAddFileModal = true;
      },
      uploadFile(file) {
        console.log('uploadFile', file)
        let fd = new FormData();
        fd.append('upfile',file.file, file.file.name);
        fd.append('reference_item_id', String(this.addFileReferenceItemId));

        referenceAddFileApi(fd).then(() => {
          notify.call(this, `Файл ${file.file.name} загружен`, "success");
        }).catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        }).finally(() => {
          this.$refs.upload.clearFiles()
          this.showAddFileModal = false
          this.loadReferences();
        });

      },
      removeFileHandler(id) {
        const params = {
          reference_item_id: id
        }

        referenceRemoveFileApi(params).then(() => {
          notify.call(this, `Файл удален`, "success");
        }).catch(() => {
          notify.call(this, "Ошибка сервера", "error");
        }).finally(() => {
          this.loadReferences();
        });
      },
      saveReferencesItem() {
        if (!this.currentReferenceId && this.newReferenceName === '') {
          return
        }

        const params = {
          reference_id: this.currentReferenceId,
          keyword: this.newReferenceName,
          group_id: parseInt(this.group),
          save_for_api: iaoApi()
        }
        getReferenceAddItemApi(params).then(() => {
          this.currentReferenceId = null;
          this.newReferenceName = '';
          this.createDialogVisible = false;
          this.loadReferences();
        })
      }
    },
    mounted() {
      this.loadReferences()

      this.$store.dispatch(GET_EXT_USERS, { parent_id: iaoApi(), limit: 500 })
      this.$store.dispatch(GET_EXT_USERS_RELS, { api_id: iaoApi() })
    },
    components: {
      ReferenceItem,
      NavBread
    }
  };
</script>

<style>
  .guides-head {
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .guides-list.guides-list-iao {
    margin-top: 30px;
  }
  .guides-list-item:not(:last-child) {
    margin-bottom: 40px;
  }
  .guides-list-item-head {
    display: flex;
    align-items: center;
    margin: 0 0 15px;
  }
  .guides-list-item-head .el-button--small, .el-button--small.is-round {
    padding: 4px 15px;
  }
  .guides-list-item-title {
    margin: 0 20px 0 0;
  }
  .guides-references-list {}
  .guides-references-list-item {}
  .guides-modal-row {}
  .guides-modal-row span {
    display: block;
    margin-bottom: 5px;
  }
  @media screen and (max-width: 480px) {
  .guides-references-keywords-edit-row .el-button {
    margin-top: 10px
  }
  .el-dialog{
    width: 80%;
  }
}
  .guides-head {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .directory-list {
    display: flex;
  }
  .guides-list-item:not(:last-child) {
    margin-bottom: 40px;
  }
  .guides-list-item-head {
    display: flex;
    align-items: center;
    margin: 20px 0 15px;
  }
  .guides-list-item-head .el-button--small, .el-button--small.is-round {
    padding: 4px 15px;
  }
  .guides-list-item-title {
    margin: 0 20px 0 0;
    padding: 10px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }
  .guides-list-item-title.active{
    background: #409EFF;
    color: white;
  }
  .directory-references-list {
    position: absolute;
    left: 100px;
    width: 80%;
  }
  .guides-references-list-item {}
  .guides-modal-row {}
  .guides-modal-row span {
    display: block;
    margin-bottom: 5px;
  }

  @media screen and (max-width: 480px) {
    .directory-references-list{
      left: 0;
      width: 100%;
    }
    .guides-references-item-head {
      display: block;
    }
    .white-space{
      white-space: break-spaces;
      margin-top: 5px;
    }
  }
</style>
